import { Fragment, SyntheticEvent } from "react";
import { Button, Tooltip } from "@mui/material";
import { FindInPage } from "@mui/icons-material";
import { IInvoice } from "../../../../api/hooks/useInvoices";

type Props = {
  row: IInvoice;
  onOpen: (e: SyntheticEvent, row: IInvoice) => void;
};

export const InvoiceActionsCell = ({ row, onOpen }: Props) => {
  return (
    <Fragment>
      <Tooltip title="View Details">
        <Button onClick={(e) => onOpen(e, row)} size="small" color="primary" sx={{ minWidth: 0 }}>
          <FindInPage fontSize="small" />
        </Button>
      </Tooltip>
    </Fragment>
  );
};
